<template>
    <div class="container" v-if="show">
        <div>
            <img class="img1" :src="$store.state.static_img_url+'pic/'+imgurl+'.png'">
            <slot></slot>
            <img class="img2" :src="$store.state.static_img_url+'pic/contact/swxq.png'">
            <p class="p2">电话/微信号：17338335471（vcbeat-m）</p>
            <i class="iconfont" @click="show=false">&#xe6bb;</i>
        </div>
    </div>
</template>
<script>
export default {
    props: ['imgurl'],
    data() {
        return {
            show: false
        }
    },
    methods: {
        goShow() {
            this.show = true
        }
    }
}
</script>
<style lang="stylus" scoped>
.container
    position fixed
    height 100%
    width 100%
    top 0
    left 0
    background rgba(0,0,0,0.3)
    z-index 1058
    display flex
    align-items center
    justify-content center
    >div
        width 580px
        height 380px
        background-image url('~pic/org-bg.png')
        background-repeat no-repeat
        background-size 100% 100%
        padding 48px 0 0
        text-align center
        position relative
        .img1
            height 48px
        .p1
            font-size 18px
            color #fff
            line-height 25px
            margin-top 14px
        .img2
            margin-top 16px
            width 160px
        .p2
            font-size 12px
            color #fff
            line-height 17px
            margin-top 8px
        .iconfont
            position absolute
            top 20px
            right 20px
            display block
            font-size 18px
            color #FFFFFF
            opacity 0.59
            cursor pointer
</style>